import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import {
  DOCUMENT_STATUS_LABEL_KEYS,
  DOCUMENT_STATUS_SEVERITY,
  DOCUMENT_TYPE_LABEL_KEYS,
  DocumentResponseDto,
} from '@taxora-shared-common/util';

@Component({
  selector: 'lib-document-row',
  templateUrl: './document-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, DecimalPipe, TranslatePipe, ButtonModule, TagModule],
})
export class DocumentRow {
  readonly document = input.required<DocumentResponseDto>();

  readonly rowClick = output<DocumentResponseDto>();
  readonly downloadClick = output<DocumentResponseDto>();

  protected readonly typeLabelKey = computed(() => DOCUMENT_TYPE_LABEL_KEYS[this.document().type]);
  protected readonly statusLabelKey = computed(
    () => DOCUMENT_STATUS_LABEL_KEYS[this.document().status],
  );
  protected readonly statusSeverity = computed(
    () => DOCUMENT_STATUS_SEVERITY[this.document().status],
  );

  protected readonly mimeIcon = computed(() => {
    const mime = this.document().storageFile.mimeType;
    if (mime === 'application/pdf') return 'pi-file-pdf';
    if (mime.startsWith('image/')) return 'pi-image';
    return 'pi-file';
  });

  protected onRowClick(): void {
    this.rowClick.emit(this.document());
  }

  protected onDownload(event: MouseEvent): void {
    event.stopPropagation();
    this.downloadClick.emit(this.document());
  }
}
